window.SST = window.SST || {};

window.SST.emit = function emit(name, detail, target) {
  (target || document).dispatchEvent(new CustomEvent(`sst:${name}`, { bubbles: true, detail }));
};

window.SST.onSectionLoad = function onSectionLoad(callback) {
  if (typeof callback !== 'function') return;
  document.addEventListener('shopify:section:load', (event) => callback(event.target));
};

document.documentElement.classList.add('sst-js');

/**
 * Drag-to-scroll for horizontal strips (the product thumbnail carousel).
 * Touch already drags natively, so this only wires up pointer/mouse. A drag of
 * more than a few pixels suppresses the click so thumbnails aren't selected by
 * accident when the user was scrubbing.
 */
window.SST.initDragScroll = function initDragScroll(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-sst-drag-scroll]').forEach((strip) => {
    if (strip.dataset.sstDragBound === 'true') return;
    strip.dataset.sstDragBound = 'true';

    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let moved = false;

    const stop = () => {
      if (pointerId === null) return;
      try {
        strip.releasePointerCapture(pointerId);
      } catch (e) {
        /* pointer already released */
      }
      pointerId = null;
      strip.classList.remove('sst-dragging');
    };

    strip.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (strip.scrollWidth <= strip.clientWidth) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = strip.scrollLeft;
      moved = false;
      // Deliberately NOT capturing here: capturing on pointerdown retargets the
      // following click to this element, so the thumbnail button never receives
      // it. Capture only once an actual drag starts.
    });

    strip.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;
      const delta = event.clientX - startX;
      if (!moved && Math.abs(delta) < 4) return;
      if (!moved) {
        moved = true;
        strip.classList.add('sst-dragging');
        try {
          strip.setPointerCapture(pointerId);
        } catch (e) {
          /* capture unavailable; plain scrolling still works */
        }
      }
      strip.scrollLeft = startScroll - delta;
    });

    strip.addEventListener('pointerup', stop);
    strip.addEventListener('pointercancel', stop);
    strip.addEventListener('click', (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
  });
};

document.addEventListener('DOMContentLoaded', () => window.SST.initDragScroll());
window.SST.onSectionLoad((section) => window.SST.initDragScroll(section));

/**
 * Autoplay for [data-sst-autoplay] scroll-snap strips. The value is the dwell
 * time in ms. Advances one slide at a time and wraps at the end. Pauses on
 * hover, focus and any manual interaction, skips entirely when the strip is not
 * actually scrollable, when the tab is hidden, or under reduced motion.
 */
window.SST.initCarouselAutoplay = function initCarouselAutoplay(root) {
  const scope = root || document;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  scope.querySelectorAll('[data-sst-autoplay]').forEach((strip) => {
    if (strip.dataset.sstAutoplayBound === 'true') return;
    strip.dataset.sstAutoplayBound = 'true';

    const delay = parseInt(strip.dataset.sstAutoplay, 10) || 5000;
    let timer = null;
    let paused = false;

    const step = () => {
      if (paused || still.matches || document.hidden) return;
      if (strip.scrollWidth <= strip.clientWidth + 1) return;
      const slide = strip.firstElementChild;
      if (!slide) return;
      const stride = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(strip).columnGap || 0);
      const atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;
      strip.scrollTo({ left: atEnd ? 0 : strip.scrollLeft + stride, behavior: 'smooth' });
    };

    const start = () => {
      if (timer) return;
      timer = window.setInterval(step, delay);
    };
    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    ['pointerenter', 'focusin'].forEach((e) => strip.addEventListener(e, () => { paused = true; }));
    ['pointerleave', 'focusout'].forEach((e) => strip.addEventListener(e, () => { paused = false; }));
    // A deliberate swipe or drag should hand control back to the visitor.
    ['pointerdown', 'wheel', 'touchstart'].forEach((e) =>
      strip.addEventListener(e, stop, { passive: true, once: true })
    );

    start();
  });
};

document.addEventListener('DOMContentLoaded', () => window.SST.initCarouselAutoplay());
window.SST.onSectionLoad((section) => window.SST.initCarouselAutoplay(section));
